import React from 'react';

import DepositMetrics from './DepositMetrics';
import DepositsList from './DepositsList';
import DepositsStats from './DepositsStats';

function DepositPage() {
    return (
        <>
            <DepositMetrics />
            <DepositsStats />
            <DepositsList />
        </>
    );
}

export default DepositPage;
